import QuestionnaireCard from './QuestionnaireCard';

export default QuestionnaireCard;
